export default __webpack_public_path__ + "static/media/womens_diamond_band.f11b4838.png";